import { useQuery } from '@tanstack/react-query';
import { fetchProfile } from '../api/profile';
import { UserProfile } from '../types/profile';

export function useProfile() {
  return useQuery<UserProfile | null>({
    queryKey: ['profile'],
    queryFn: fetchProfile,
    staleTime: 1000 * 30,
  });
}


